import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Cookies from "js-cookie";
import './Header.css';
import Service from '../service/Service';
import { Bling as GPT } from "react-gpt";

const service = new Service();

class Header extends Component {
    constructor(props) {
        super(props);
        this.loggedin = false;
        var enableOneTap = false;
        if (__isBrowser__ && window.__initialData__) {
            if (window.__initialData__['authData']['ftk'] != "") {
                this.loggedin = true;
            }
            if (window.__initialData__['location']) {
                global.currentURL = window.__initialData__['location'];
            }
            if (window.__initialData__['validAuth'] && window.__initialData__['validAuth'] == "no") {
                this.handleInvalidAuth(this.loggedin);
            }
            this.setAuthData(window.__initialData__['authData']);
        } else {
            if (props.staticContext && props.staticContext.initialData) {
                if (props.staticContext.initialData['authData']['ftk'] != "") {
                    this.loggedin = true;
                }
                if (props.staticContext.initialData['location']) {
                    global.currentURL = props.staticContext.initialData['location'];
                }
                this.setAuthData(props.staticContext.initialData['authData']);
            }
        }
        let isMsite = true;
        this.isApp = false;
        let isDesktop = true;
          if (__isBrowser__) {
            this.checkView = this.checkView.bind(this);
            let x = window.matchMedia("(max-width: 767px)");
            if (x.matches) {
                isMsite = true;
                isDesktop = false;
            } else {
                isMsite = false;
                isDesktop = true;
            }
            x.addListener(this.checkView) // Attach listener function on state changes
        }
        if (props.location.search.includes('from=app')) {
            this.isApp = true;
        }
     
          if (this.props.location.pathname.includes('/amp/')) {
            var isLogin, userPhoto, loginUname;
            if (global.userAry['userPhoto'] && global.userAry['userPhoto'] != '') {
                userPhoto = global.userAry['userPhoto'];
            } else {
                userPhoto = 'https://cdn.cdnparenting.com/brainbees/community/preact/public/media/default-img.png';
            }
            if (global.userAry['userName'] && global.userAry['userName'] != '') {
                loginUname = global.userAry['userName'];
            } else {
                loginUname = 'Community User';
            }
            this.state = {
                childArr: [],
                userPhoto: 'https://cdn.fcglcdn.com/brainbees/parenting/img/m/default-img.png',
                loginUname: 'Community User',
                isLogin: this.loggedin,
                showPopupAd: true,
                value: "",
                autocompleteData: [],
                isCall: true,
                enableOneTap: enableOneTap,
                placeholder: 'Articles, Baby Names and more',
                isMsite: isMsite,
                isDesktop: isDesktop,
                drpdwn: false,
                mainCntclass: '',
                rightContentExists: false,
                stopScroll: 0,
                isSearchFound: false
            }
        } else {
                this.state = {
                    childArr: [],
                    userPhoto: 'https://cdn.fcglcdn.com/brainbees/parenting/img/m/default-img.png',
                    loginUname: 'Community User',
                    isLogin: this.loggedin
                }
        }
        global.drpdnHover = false;
        let today = new Date();
        let monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        let week = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        this.dateNew = week[today.getDay()] + ', ' + monthNames[today.getMonth()] + ' ' + today.getDate() + ' ' + today.getFullYear();
        this.menuData = require('./Menu.json');
        this.maintainLastScroll = 0;
    };
    checkView(x) {
        if (x.matches) { // If media query matches
            console.log("msite");
            this.setState({
                isMsite: true,
                isDesktop: false
            }, () => {
                service.loadImages();
            })
            return true;
        } else {
            console.log("desktop");
            this.setState({
                isMsite: false,
                isDesktop: true
            }, () => {
                service.loadImages();
            })
            return false;
        }
    }
    componentDidMount() {
        if (this.isApp) {
            document.getElementsByClassName('title')[0].style.display = 'none';
            // document.getElementsByClassName('data-container')[0].style.marginBottom = '50px';
            document.querySelector(".sub-container").style.marginBottom = "42px";
        }
        if (!navigator.onLine) {
            if (localStorage.getItem('authData')) {
                let authData = {};
                authData = JSON.parse(localStorage.getItem('authData'));
                this.setAuthData(authData);
            }
        } else {
            this.setUserData();
        }
        if (global.ftk != '') {
            this.setState({ isLogin: true });
        } else {
            this.setState({ isLogin: false });
        }
        if (global.userAry['userPhoto'] && global.userAry['userPhoto'] != '') {
            this.setState({ userPhoto: global.userAry['userPhoto'] });
        }
        if (global.userAry['userName'] && global.userAry['userName'] != '') {
            this.setState({ loginUname: global.userAry['userName'] });
        }
        window.addEventListener('scroll', this.handleScroll);
        setTimeout(() => {
            service.loadImages();
        }, 100)
    }

    componentWillMount() {
        this.unlisten = this.props.history.listen((location, action) => {
            this.closeMobileMenu();
        });
    }

    componentWillUnmount() {
        this.unlisten();
    }

    handleInvalidAuth(loggedin) {
        if (loggedin) {
            window.location.href = global.logoutUrl + '?URL=' + window.location.href;
            return false;
        } else {
            window.location.href = global.loginUrl + '?URL=' + window.location.href;
            return false;
        }
    }

    setUserData() {
        let authData = {};
        authData['ftk'] = global.ftk;
        authData['clientId'] = global.clientId;
        authData['uId'] = global.uID;
        authData['token'] = {};
        authData['token']['access-token'] = global.accessToken;
        authData['token']['mycid'] = global.userAry['mycid'];
        authData['childData'] = {};
        authData['childData']['UserMaster'] = {};
        authData['childData']['UserMaster']['userPhoto'] = global.userAry['userPhoto'];
        authData['childData']['UserMaster']['firstname'] = global.userAry['userName'];
        authData['childData']['UserMaster']['Sex'] = global.userAry['Sex'];
        authData['childData']['UserChildList'] = global.userAry['childData']['UserChildList'];
        authData['childData']['UserMaster']['IsTryingToConceive'] = global.userAry['IsTryingToConceive'];
        authData['childData']['UserMaster']['EmailAddress'] = global.userAry['EmailAddress'];
        authData['childData']['UserMaster']['mobileno'] = global.userAry['mobileno'];
        localStorage.setItem('authData', JSON.stringify(authData));
    }

    setAuthData(authData) {
        global.userAry['mycid'] = "";
        global.userAry['userPhoto'] = "";
        global.userAry['userName'] = "";
        global.userAry['Sex'] = "";
        global.userAry['IsTryingToConceive'] = 0;
        global.userAry['EmailAddress'] = '';
        global.userAry['mobileno'] = '';
        global.userAry['childData'] = [];
        global.userAry['IsExpected'] = false;
        global.userAry['expectedDob'] = "";
    
        if (this.props.location.pathname.includes('/amp/')) {
            global.ftk = authData['ftk'];
        } else if(this.props.location.search.includes('from=app')){ 
            if (authData['ftk']) {
                global.ftk = authData['ftk'];
            }else{    
                global.ftk = (authData['app_ftk']!="")?Cookies.get("app_ftk"):authData['ftk'];
            }
            console.log("header app_ftk: ",global.ftk);
        }else{
            if (authData['ftk']) {
                global.ftk = authData['ftk'];
            } else if (Cookies.get("FC_AUTH")) {
                global.ftk = Cookies.get("FC_AUTH");
            }
        }

        if (authData['clientId']) {
            global.clientId = authData['clientId'];
        }
        if (authData['uId']) {
            global.uID = authData['uId'];
        }
        if (authData['token']['access-token']) {
            global.accessToken = authData['token']['access-token'];
        }
        if (authData['token']['mycid']) {
            global.userAry['mycid'] = authData['token']['mycid'];
        }
        if (authData['childData']) {
            global.userAry['childData'] = authData['childData'];
            if (authData['childData']['UserMaster'] && authData['childData']['UserMaster']['userPhoto']) {
                global.userAry['userPhoto'] = authData['childData']['UserMaster']['userPhoto'];
            }
            if (authData['childData']['UserMaster'] && authData['childData']['UserMaster']['firstname']) {
                global.userAry['userName'] = authData['childData']['UserMaster']['firstname'];
            }
            if (authData['childData']['UserMaster'] && authData['childData']['UserMaster']['Sex']) {
                global.userAry['Sex'] = authData['childData']['UserMaster']['Sex'];
            }
            if (authData['childData']['UserMaster'] && authData['childData']['UserMaster']['IsTryingToConceive']) {
                global.userAry['IsTryingToConceive'] = authData['childData']['UserMaster']['IsTryingToConceive'];
            }
            if (authData['childData']['UserMaster'] && authData['childData']['UserMaster']['EmailAddress']) {
                global.userAry['EmailAddress'] = authData['childData']['UserMaster']['EmailAddress'];
            }
            if (authData['childData']['UserMaster'] && authData['childData']['UserMaster']['mobileno']) {
                global.userAry['mobileno'] = authData['childData']['UserMaster']['mobileno'];
            }
            if (authData['childData']['UserChildList'] && authData['childData']['UserChildList'].length > 0 && authData['childData']['UserChildList'][0]['IsExpected']) {
                global.userAry['IsExpected'] = authData['childData']['UserChildList'][0]['IsExpected'];
                global.userAry['expectedDob'] = authData['childData']['UserChildList'][0]['DOB'];
            }
        }
        let cookieObj = {};
        cookieObj.authTokenRes = authData['token'];
        cookieObj.uId = global.uID;
        cookieObj.clientId = global.clientId;
        Cookies.set("parentingAuthData", JSON.stringify(cookieObj), { domain: '.firstcry.ae' });
    }

    openSubMenu(event) {
        let el = event.target.closest(".shop_menucat");
        if (el.classList.contains('menuOpen')) {
            el.classList.remove('menuOpen');
            el.style.backgroundColor = 'unset';
            el.nextSibling.style.display = 'none';
            let ary = document.getElementsByClassName('shop_menucat');
            for (let i = 0; i < ary.length; i++) {
                ary[i].classList.remove('menuOpen');
                ary[i].style.backgroundColor = 'unset';
            }
            let iAry = document.getElementsByClassName('dash_link');
            for (let j = 0; j < iAry.length; j++) {
                iAry[j].setAttribute("data-icon-font", "8");
            }
            document.getElementById('Readmenulist').style.display = 'none';
           
            document.getElementById('parentingtoollist').style.display = 'none';
            document.getElementById('pregnancytoollist').style.display = 'none';
            document.getElementById('othertoollist').style.display = 'none';
        } else {
            let ary = document.getElementsByClassName('shop_menucat');
            for (let i = 0; i < ary.length; i++) {
                ary[i].classList.remove('menuOpen');
                ary[i].style.backgroundColor = 'unset';
            }
            let iAry = document.getElementsByClassName('dash_link');
            for (let j = 0; j < iAry.length; j++) {
                iAry[j].setAttribute("data-icon-font", "8");
            }
            document.getElementById('Readmenulist').style.display = 'none';
            
            document.getElementById('parentingtoollist').style.display = 'none';
            document.getElementById('pregnancytoollist').style.display = 'none';
            document.getElementById('othertoollist').style.display = 'none';
            el.classList.add('menuOpen');
            el.nextSibling.style.display = 'block';
            el.getElementsByClassName('dash_link')[0].setAttribute("data-icon-font", "Z");
            el.style.backgroundColor = '#f5f5f5';
        }
        var cHeight = document.getElementsByClassName('td-mobile-container')[0].offsetHeight;
        document.getElementsByClassName('closingdiv')[0].style.height = cHeight + 'px';
    }

    openMobileMenu() {
        if (document.getElementsByClassName('arrow_link')[0]) {
            document.getElementsByClassName('arrow_link')[0].style.display = 'block';
        }
        document.getElementById('td-mobile-nav').classList.add("active");
        var height = document.getElementById('td-mobile-nav').offsetHeight;
        document.getElementsByClassName('td-mobile-container')[0].style.minHeight = height + 'px';
        var cHeight = document.getElementsByClassName('td-mobile-container')[0].offsetHeight;
        document.getElementsByClassName('closingdiv')[0].style.height = (height > cHeight ? height : cHeight) + 'px';
        document.getElementsByClassName('user_pro')[0].style.height = (document.getElementsByClassName('user_back_img')[0].getElementsByTagName('img')[0].offsetHeight - 9) + 'px';
        document.getElementsByTagName('body')[0].style.overflow = 'hidden';
        setTimeout(function () {
            document.getElementsByClassName('closingdiv')[0].style.display = 'block';
        }, 400);
    }

    closeMobileMenu() {
        setTimeout(function () {
            if (document.getElementsByClassName('closingdiv')[0]) {
                document.getElementsByClassName('closingdiv')[0].style.display = 'none';
            }
        }, 400);
        document.getElementsByTagName('body')[0].style.overflow = 'visible';
        if (document.getElementById('td-mobile-nav')) {
            document.getElementById('td-mobile-nav').classList.remove("active");
        }
    }

    toggleHover() {
        global.drpdnHover = !global.drpdnHover;
        if (global.drpdnHover) {
            document.getElementsByClassName('header-top-dropdown')[0].style.display = 'block';
        } else {
            document.getElementsByClassName('header-top-dropdown')[0].style.display = 'none';
        }
    }

    handleScroll() {
        if (document.getElementsByClassName('registrationRight')[0]) {
            document.getElementsByClassName('registrationRight')[0].style.height = document.getElementsByClassName('sub-container')[0].offsetHeight;
        }
        if (window.innerWidth > 767) {
            if (document.getElementsByClassName('header_menus_container')[0]) {
                if (window.scrollY > document.getElementsByClassName('header_menus_container')[0].offsetTop) {
                    document.getElementsByClassName('header_menus_container')[0].classList.add('headerTopFix');
                } else {
                    document.getElementsByClassName('header_menus_container')[0].classList.remove('headerTopFix');
                }
            }
        } else {
            if (document.getElementsByClassName('mobile_header')[0]) {
                if (window.scrollY > document.getElementsByClassName('mobile_header')[0].offsetTop) {
                    document.getElementsByClassName('mobile_header')[0].classList.add('mobileHeadTopfix');
                } else {
                    document.getElementsByClassName('mobile_header')[0].classList.remove('mobileHeadTopfix');
                }
            }
        }
        if (document.getElementsByClassName('td-scroll-up')[0]) {
            if (window.scrollY > 80 && window.innerWidth > 767) {
                document.getElementsByClassName('td-scroll-up')[0].style.display = 'block';
            } else {
                document.getElementsByClassName('td-scroll-up')[0].style.display = 'none';
            }
        }
        service.sticky_div();
    }

    toggleSite(event) {
        if (event.target.checked) {
            window.open(global.redirect_url, '_blank');
        } else {
            window.open('https://www.firstcry.ae/?ref=parenting&utm_source=parenting_footer&utm_medium=parenting_msite&utm_campaign=promote_parenting&utm_content=parenting_switch_return', '_blank');
        }
    }

    scrollToTop = () => {
        let element = document.documentElement;
        let to = 0;
        let duration = 500;

        var start = element.scrollTop,
            change = to - start,
            currentTime = 0,
            increment = 20;
        var easeInOutQuad = function (t, b, c, d) {
            t /= d / 2;
            if (t < 1) return c / 2 * t * t + b;
            t--;
            return -c / 2 * (t * (t - 2) - 1) + b;
        };

        var animateScroll = function () {
            currentTime += increment;
            var val = easeInOutQuad(currentTime, start, change, duration);
            element.scrollTop = val;
            if (currentTime < duration) {
                setTimeout(animateScroll, increment);
            }
        };
        animateScroll();
    }

    render() {
        const fullWidth = { width: '100%' };
        const dNone = { display: 'none' };
        if (this.props.location.pathname.includes('/amp/')) {
            const parenting_img = {
                marginRight: "24px",
                float: "left",
                width: "272px"
            }
            return (
                <div>
                    {this.state.enableOneTap && !this.isApp &&
                        <div id="g_id_onload"
                            data-client_id="834141296178-3itknsh2mneibsovevaoltkhrcadp6vv.apps.googleusercontent.com"
                            data-callback="handleCredentialResponse"
                            data-cancel_on_tap_outside="false"
                            data-skip_prompt_cookie="FC_AUTH">
                        </div>
                    }
                    <div id="hidden_tracking"></div>
                    <div className="alertMsg-overlay" id="ampAlertMsg" hidden>
                        <div className="alert-popup">
                            <span className="alertmsg">Please Login</span>
                        </div>
                    </div>
                    {!this.isApp &&
                        <header style={fullWidth}>
                            <div className="td-scroll-up" onClick={this.scrollToTop}><span className="icon" data-icon-font="m"></span></div>
                            <div className="toggle-main" >
                                <div className="toggle-shopping">SHOPPING</div>
                                <div className="toggle-btn">
                                    <a href="https://www.firstcry.com/?ref=parenting&utm_source=parenting_footer&utm_medium=parenting_msite&utm_campaign=promote_parenting&utm_content=parenting_switch_return" target="_blank">
                                        {/* <input id="toggleSiteBtn" type="checkbox" checked aria-label="toggle" />
                                        <label htmlFor="toggleSiteBtn" className="switch">
                                            <span className="slider round"></span>
                                        </label> */}
                                        <div className="switch">
                                            <span className="slider round"></span>
                                        </div>
                                    </a>
                                </div>
                                <div className="toggle-parenting">PARENTING</div>
                            </div>
                            {this.state.isDesktop &&
                                <div className="desktop_header" >
                                    <div className="header_container">
                                        <section className="login_info_container">
                                            <div className="userinfo">
                                                <div className="right">
                                                    <span className="today_date right R12_white">{this.dateNew}</span>
                                                    <div className="login_info R12_white">
                                                        {this.state.isLogin && global.ftk != "" ?
                                                            <div className="loggedin">
                                                                <div className="R12_white user_info" onMouseEnter={this.toggleHover} onMouseLeave={this.toggleHover}>
                                                                    <ul className="header-top-dropdown">
                                                                        {this.menuData && this.menuData.dropdown && this.menuData.dropdown.map((item, i1) => (
                                                                            <li key={i1}><a href={service.getRedirectUrl(item.url)}>{item.name}</a></li>
                                                                        ))}
                                                                        <li><a href={service.getRedirectUrl(global.logoutUrl + '?URL=' + global.currentURL)} className="logoutuser">Log Out</a></li>
                                                                    </ul>
                                                                    <a href={service.getRedirectUrl("/my-account")} className="loggedinusername"> {this.state.loginUname}&#39;s account <span className="dropdown-arrow"></span></a>
                                                                </div>
                                                            </div>
                                                            :
                                                            <span className="nonloggedin">
                                                                <a href={service.getRedirectUrl(global.loginUrl + '?URL=' + global.currentURL)}>Login</a>
                                                                <span className="login_divider" >|</span>
                                                                <a href={service.getRedirectUrl(global.registerUrl + '?URL=' + global.currentURL)}>Register</a>
                                                            </span>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </section>
                                        <section className="header_images_container">
                                            <span className="parenting_img left" style={parenting_img}>
                                                <a href={service.getRedirectUrl("/")} className="Left">
                                                    <amp-img layout="responsive" height="90" width="272" src="https://parenting.firstcry.ae/memories/getMyMemoryImages/2019/07/16113904/logo-header-new-ae3.png" alt="Logo" ></amp-img>
                                                </a>
                                            </span>
                                            {/* <span className="dfp_banner left">
                                            <div className="desktop-ads-block">
                                                <div id="div-gpt-ad-1592983059853-0" style={{ width: '728px', height: '90px', overflow: 'hidden', margin: '0 auto' }}>
                                                    <GPT
                                                        adUnitPath="/84382175/parenting.com/parenting.com_allcustompages_header_tools_baby_names_memories_desktop"
                                                        slotSize={[728, 90]}
                                                    />
                                                </div>
                                            </div>
                                        </span> */}
                                        </section>
                                        <section className="header_menus_container">
                                            <ul id="menu">
                                                {this.menuData && this.menuData.desktop && this.menuData.desktop.map((item, i1) => (
                                                    <li key={i1} className={item.class}>
                                                        <a href={service.getRedirectUrl(item.url)} className="M14_42" rel="noopener noreferrer">
                                                            <span className="B12_42 main_menu_title">{item.name}</span>
                                                            {item.submenu && item.submenu.length > 0 &&
                                                                <span className="icon" data-icon-font="j"></span>
                                                            }
                                                        </a>
                                                        {item.submenu && item.submenu.length > 0 &&
                                                            <ul className={item.subclass}>
                                                                {item.submenu.map((subitem, i2) => (
                                                                    <li key={i2}>
                                                                        <a href={service.getRedirectUrl(subitem.url)} className="R14_75">
                                                                            {subitem.name}
                                                                            {subitem.subsubmenu && subitem.subsubmenu.length > 0 &&
                                                                                <span className="icon right" data-icon-font="l"></span>
                                                                            }
                                                                        </a>
                                                                        {subitem.subsubmenu && subitem.subsubmenu.length > 0 &&
                                                                            <ul className={item.subsubclass}>
                                                                                {subitem.subsubmenu.map((subsubitem, i3) => (
                                                                                    <li key={i3}>
                                                                                        <a href={service.getRedirectUrl(subsubitem.url)} className="R14_75">{subsubitem.name}</a>
                                                                                    </li>
                                                                                ))}
                                                                            </ul>
                                                                        }
                                                                    </li>
                                                                ))}
                                                            </ul>
                                                        }
                                                    </li>
                                                ))}
                                            </ul>
                                        </section>
                                    </div>
                                </div>
                            }
                            {/* {this.state.isMsite &&
                                <span className="dfp_banner_mobile">
                                    <div className="msite-ads-block">
                                        <div id="div-gpt-ad-1606043895181-0" style={{ width: '320px', height: '50px', overflow: 'hidden', margin: '0 auto' }}>
                                            <GPT
                                                adUnitPath="/84382175/parenting.com/parenting.com_allcustompages_tools_baby_names_memories_header_msite"
                                                slotSize={[[320, 100], [320, 50], [360, 96], [414, 96], [375, 96], [411, 96]]}
                                            />
                                        </div>
                                    </div>
                                </span>
                            } */}
                            {this.state.isMsite &&
                                <div className="mobile_header">
                                    <div className="hamburgermenu_icon" tabIndex="0" role="button" on="tap:AMP.setState({activeclass: 'openmenu'})">
                                        <div className="toggle_icon">
                                            <span className="menuIcon"></span>
                                            <span className="menuIcon"></span>
                                            <span className="menuIcon"></span>
                                        </div>
                                    </div>
                                    <div className="firstcryImg">
                                        <a href={service.getRedirectUrl("/")}>
                                            <amp-img layout="responsive" height="54" width="163" src="https://cdn.cdnparenting.com/articles/2018/01/logo-header-mobile.png" alt="Parenting Firstcry" title="Parenting Firstcry" ></amp-img>
                                        </a>
                                    </div>
                                    <div id="td-mobile-nav" data-amp-bind-class="mobStyle[activeclass].active">
                                        <div className="closingdiv" data-amp-bind-class="mobStyle[activeclass].openingdiv" tabIndex="0" role="button" on="tap:AMP.setState({activeclass: 'closemenu'})">
                                            <div className="td-mobile-container">
                                                <div className="td-mobile-content">
                                                    <ul id="menu-td-demo-header-menu" className="td-mobile-main-menu">
                                                        <li className="user-profile">
                                                            <ul className="user_back_img ">
                                                                <li>
                                                                    <amp-img layout="responsive" height="100" width="100" src={"https://cdn.cdnparenting.com/brainbees/community/preact/public/media/parenting-menu.jpg"} alt="" class="loadingImg" ></amp-img>
                                                                </li>
                                                            </ul>
                                                            <ul className="user_pro menucls">
                                                                <li>
                                                                    <span className="usr-prof">
                                                                     {this.state.isLogin && global.ftk != "" ?
                                                                        <a href={service.getRedirectUrl('/my-account/myprofile_mobile')} target="_self">
                                                                            <ul>
                                                                                {this.state.isLogin && global.ftk != "" ?
                                                                                    <li className="user_pro_img" id="profile_img">
                                                                                        {this.state.userPhoto && this.state.userPhoto != '' ?
                                                                                            <amp-img layout="responsive" height="40" width="40" src={this.state.userPhoto.replace("http://", "https://")} alt="" class="loadingImg" ></amp-img>
                                                                                            :
                                                                                            <span>
                                                                                                {this.state.loginUname && this.state.loginUname != '' ?
                                                                                                    <span className="u-single" >{this.state.loginUname.charAt(0).toUpperCase()}</span>
                                                                                                    :
                                                                                                    <span className="icon" data-icon-font="?"></span>
                                                                                                }
                                                                                            </span>

                                                                                        }
                                                                                    </li>
                                                                                    :
                                                                                    <li className="user_pro_img" id="profile_img">
                                                                                        <span className="icon" data-icon-font="?"></span>
                                                                                    </li>
                                                                                }
                                                                                <li className="R13_white user-name" id="user_name">
                                                                                    {this.state.isLogin && global.ftk != "" && this.state.loginUname && this.state.loginUname != '' ?
                                                                                        <span>{this.state.loginUname}</span>
                                                                                        :
                                                                                        <span>
                                                                                            <a href={service.getRedirectUrl(global.loginUrl + '?URL=' + global.currentURL)} target="_self">Login </a>
                                                                                            <span> / </span>
                                                                                            <a href={service.getRedirectUrl(global.registerUrl + '?URL=' + global.currentURL)} target="_self"> Register</a>
                                                                                        </span>
                                                                                    }
                                                                                </li>
                                                                                {this.state.isLogin && global.ftk != "" &&
                                                                                    <li>
                                                                                        <span className="arrow_link icon" data-icon-font="l"></span>
                                                                                    </li>
                                                                                }
                                                                            </ul>
                                                                            </a>
                                                                        :
                                                                         <li className="user_pro_img" id="profile_img">
                                                                                <span className="icon" data-icon-font="?"></span>
                                                                            </li>
                                                                        }

                                                                    </span>
                                                                </li>
                                                            </ul>
                                                        </li>
                                                        {this.menuData && this.menuData.mobile && this.menuData.mobile.map((item, i1) => (
                                                            <li key={i1}>
                                                                {item.submenu && item.submenu.length > 0 ?
                                                                    <ul>
                                                                        <li className="shop_menucat" tabIndex="0" role="button" on={`tap:Readmenulist.hide, Magazinemenulist.hide, parentingtoollist.hide, pregnancytoollist.hide, othertoollist.hide, ${item.subid}.toggleVisibility, AMP.setState({ Readmenulist:'closesubmenu', Magazinemenulist:'closesubmenu', parentingtoollist:'closesubmenu', pregnancytoollist:'closesubmenu', othertoollist:'closesubmenu',${item.subid}: 'opensubmenu'}), read_id_1.show, magazine_id_1.show, parenting_id_1.show, pragnency_id_1.show, other_tools_id_1.show, read_id_2.hide, magazine_id_2.hide, parenting_id_2.hide, pragnency_id_2.hide, other_tools_id_2.hide, ${item.arrowid}_1.toggleVisibility, ${item.arrowid}_2.toggleVisibility`}>
                                                                            <ul className="menucls" data-amp-bind-class={`mobStyle[${item.subid}]`}>
                                                                                <li className="opening_list">
                                                                                    <ul className="menucls">
                                                                                        <li className="menu_icon left" >
                                                                                            <amp-img layout="responsive" height="20" width="20" class="loadingImg menucls" src={item.image.replace("http://", "https://")} alt="" ></amp-img>
                                                                                        </li>
                                                                                        <li className="R15_42 menu_icon_txt left">{item.name}</li>
                                                                                        <li id={`${item.arrowid}_1`} className="dash_link right" data-icon-font="8" ></li>
                                                                                        <li id={`${item.arrowid}_2`} className="dash_link right" data-icon-font="Z" hidden></li>
                                                                                    </ul>
                                                                                </li>
                                                                            </ul>
                                                                        </li>
                                                                        <li id={item.subid} className="sublist" hidden>
                                                                            <ul className="menucls">
                                                                                {item.submenu.map((subitem, i2) => (
                                                                                    <a href={subitem.url} key={i2}>
                                                                                        <li className="R14_75 menu_icon_txt shop_item"> {subitem.name} </li>
                                                                                    </a>
                                                                                ))}
                                                                            </ul>
                                                                        </li>
                                                                    </ul>
                                                                    :
                                                                    <ul>
                                                                        <li className="shop_menucat">
                                                                            <a href={service.getRedirectUrl(item.url)} className="left" aria-label={item.name}>
                                                                                <ul className="menucls" >
                                                                                    <li className="menu_icon left">
                                                                                        <amp-img layout="responsive" height="20" width="20" class="loadingImg menucls" src={item.image.replace("http://", "https://")} alt="" ></amp-img>
                                                                                    </li>
                                                                                    <li className="R15_42 menu_icon_txt left">{item.name}</li>
                                                                                </ul>
                                                                            </a>
                                                                        </li>
                                                                    </ul>
                                                                }
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                        </header>
                    }
                </div>
            );
        } else {
        return (
            <div>
                <div id="hidden_tracking"></div>
                <div className="loader-overlay">
                    <div className="loader-img"><img src="https://cdn.cdnparenting.com/articles/babynameimages/loader.gif" alt="" /></div>
                </div>
                <div className="alertMsg-overlay">
                    <div className="alert-popup">
                        <span className="alertmsg"></span>
                    </div>
                </div>
                    
                {!this.isApp &&
                    <header className="left" style={fullWidth}>
                        <div className="toggle-main">
                            <div className="toggle-shopping">SHOPPING</div>
                            <div className="toggle-btn">
                                <input id="toggleSiteBtn" type="checkbox" checked onChange={(e) => this.toggleSite(e)} />
                                <label htmlFor="toggleSiteBtn" className="switch">
                                    <span className="slider round"></span>
                                </label>
                            </div>
                            <div className="toggle-parenting">PARENTING</div>
                        </div>
                        <div className="td-scroll-up" onClick={this.scrollToTop}><span className="icon" data-icon-font="m"></span></div>
                        <div className="desktop_header">
                            <div className="header_container">
                                <section className="login_info_container">
                                    <div className="userinfo">
                                    <div className="header-sp-top-widget">
                                            <span className="td-social-icon-wrap">
                                                <a target="_blank" rel="nofollow" href="https://www.facebook.com/FirstCryParenting/" title="Facebook">
                                                    <span className="header_icons footer_facebook" data-icon-font="J"></span>
                                                    {/* <i className="td-icon-font td-icon-facebook"></i> */}
                                                </a>
                                            </span>
                                            <span className="td-social-icon-wrap">
                                                <a target="_blank" rel="nofollow" href="https://www.instagram.com/firstcryparenting/" title="Instagram">
                                                    <span className="header_icons footer_instagram" data-icon-font="&#xe031;"></span>
                                                    {/* <i className="td-icon-font td-icon-instagram"></i> */}
                                                </a>
                                            </span>
                                            <span className="td-social-icon-wrap pinterest_header">
                                                <a target="_blank" rel="nofollow" href="https://in.pinterest.com/firstcryparenting" title="Pinterest">
                                                <img className="footer_icons footer_pinterest" src="data:image/png;base64,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"/>
                                                    {/* <i className="td-icon-font td-icon-twitter"></i> */}
                                                </a>
                                            </span>
                                            <span className="td-social-icon-wrap">
                                                <a target="_blank" rel="nofollow" href="https://twitter.com/firstcryparenting" title="Twitter">
                                                <span className="header_icons footer_twitter" data-icon-font="&#xe018;"></span>
                                                    {/* <i className="td-icon-font td-icon-twitter"></i> */}
                                                </a>
                                            </span>
                                            <span className="td-social-icon-wrap">
                                                <a target="_blank" rel="nofollow" href="https://www.youtube.com/firstcryparenting" title="Youtube">
                                                <span className="header_icons footer_youtube" data-icon-font="&#xe036;"></span>
                                                    {/* <i className="td-icon-font td-icon-youtube"></i> */}
                                                </a>
                                            </span>
                                        </div>
                                        <span className="login_info R12_white">
                                            {this.state.isLogin && global.ftk != "" ?
                                                <div className="loggedin">
                                                    <div className="user_info R12_white" onMouseEnter={this.toggleHover} onMouseLeave={this.toggleHover}>
                                                        <ul className="header-top-dropdown">
                                                            {this.menuData && this.menuData.dropdown && this.menuData.dropdown.map((item, i1) => (
                                                                <li key={i1}><a href={service.getRedirectUrl(item.url)}>{item.name}</a></li>
                                                            ))}
                                                            <li><a href={global.logoutUrl + '?URL=' + global.currentURL} className="logoutuser">Log Out</a></li>
                                                        </ul>
                                                        <a href={service.getRedirectUrl("/my-account")}> {this.state.loginUname}&#39;s account <span className="dropdown-arrow"></span></a>
                                                    </div>
                                                </div>
                                                :
                                                <span className="nonloggedin">
                                                    <a href={service.getRedirectUrl(global.loginUrl + '?URL=' + global.currentURL)}>Login</a>
                                                    <span className="login_divider" >|</span>
                                                    <a href={service.getRedirectUrl(global.registerUrl + '?URL=' + global.currentURL)}>Register</a>
                                                </span>
                                            }
                                        </span>
                                        <span className="today_date right R12_white">{this.dateNew}</span>
                                    </div>
                                </section>
                                <section className="header_images_container">
                                    <span className="parenting_img left">
                                        <a href={service.getRedirectUrl("/")} className="Left">
                                            <img src="https://parenting.firstcry.ae/memories/getMyMemoryImages/2019/07/16113904/logo-header-new-ae3.png" alt="Logo" />
                                        </a>
                                    </span>
                                    <span className="dfp_banner left">
                                        <div className="desktop-ads-block">
                                            <div id="div-gpt-ad-1526375995585-0" style={{ width: '728px', height: '90px', overflow: 'hidden', margin: '0 auto' }}>
                                                <GPT
                                                    adUnitPath="/106924862/728*90_parenting_site_ds"
                                                    slotSize={[728, 90]}
                                                />
                                            </div>
                                        </div>
                                    </span>
                                </section>
                                <section className="header_menus_container">
                                    <ul id="menu">
                                        {this.menuData && this.menuData.desktop && this.menuData.desktop.map((item, i1) => (
                                            <li key={i1} className={item.class}>
                                                <a href={service.getRedirectUrl(item.url)} className="M14_42" rel="noopener noreferrer" target={item.name.toLowerCase() == "shop" ? "_blank" : "_self"}>
                                                    <span className="B12_42 main_menu_title">{item.name}</span>
                                                    {item.submenu && item.submenu.length > 0 &&
                                                        <span className="icon" data-icon-font="j"></span>
                                                    }
                                                </a>
                                                {item.submenu && item.submenu.length > 0 &&
                                                    <ul className={item.subclass}>
                                                        {item.submenu.map((subitem, i2) => (
                                                            <li key={i2}>
                                                                <a href={service.getRedirectUrl(subitem.url)} className="R14_75">
                                                                    {subitem.name}
                                                                    {subitem.subsubmenu && subitem.subsubmenu.length > 0 &&
                                                                        <span className="icon right" data-icon-font="l"></span>
                                                                    }
                                                                </a>
                                                                {subitem.subsubmenu && subitem.subsubmenu.length > 0 &&
                                                                    <ul className={item.subsubclass}>
                                                                        {subitem.subsubmenu.map((subsubitem, i3) => (
                                                                            <li key={i3}>
                                                                                <a href={service.getRedirectUrl(subsubitem.url)} className="R14_75">{subsubitem.name}</a>
                                                                            </li>
                                                                        ))}
                                                                    </ul>
                                                                }
                                                            </li>
                                                        ))}
                                                    </ul>
                                                }
                                            </li>
                                        ))}
                                    </ul>
                                </section>
                            </div>
                        </div>
                        <span className="dfp_banner_mobile">
                            <div className="msite-ads-block">
                                <div id="div-gpt-ad-1526378563415-0" style={{ width: '360px', height: '72px', overflow: 'hidden', margin: '0 auto' }}>
                                    <GPT
                                        adUnitPath="/106924862/360*72_parenting_header_msite"
                                        slotSize={[360, 72]}
                                    />
                                </div>
                            </div>
                        </span>
                        <div className="mobile_header">
                            <div className="hamburgermenu_icon" onClick={this.openMobileMenu}>
                                <div className="toggle_icon">
                                    <span className="menuIcon"></span>
                                    <span className="menuIcon"></span>
                                    <span className="menuIcon"></span>
                                </div>
                            </div>
                            <div className="firstcryImg">
                                <a href={service.getRedirectUrl("/")}>
                                    <img src="https://parenting.firstcry.ae/memories/getMyMemoryImages/2019/07/16114036/logo-header-mobile-ae-3.png" alt="Parenting Firstcry" title="Parenting Firstcry" />
                                </a>
                            </div>
                            <div id="td-mobile-nav">
                                <div className="td-mobile-container">
                                    <div className="td-mobile-content">
                                        <ul id="menu-td-demo-header-menu" className="td-mobile-main-menu">
                                            <li className="user-profile">
                                                <ul className="user_back_img ">
                                                    <li>
                                                        <img src="https://cdn.cdnparenting.com/articles/babynameimages/loader.gif" data-src={require('../assets/images/parenting-menu.jpg')} alt="" className="loadingImg" />
                                                    </li>
                                                </ul>
                                                <ul className="user_pro menucls">
                                                    <li>
                                                        <span className="usr-prof">
                                                         {this.state.isLogin && global.ftk != "" ?
                                                            <a href={service.getRedirectUrl('/my-account/myprofile_mobile')} target="_self">
                                                            <ul>
                                                                {this.state.isLogin && global.ftk != "" ?
                                                                    <li className="user_pro_img" id="profile_img">
                                                                        {this.state.userPhoto && this.state.userPhoto != '' ?
                                                                            <img src="https://cdn.cdnparenting.com/articles/babynameimages/loader.gif" data-src={this.state.userPhoto.replace("http://", "https://")} alt="" className="loadingImg" />
                                                                            :
                                                                            <span>
                                                                                {this.state.loginUname && this.state.loginUname != '' ?
                                                                                    <span className="u-single" >{this.state.loginUname.charAt(0).toUpperCase()}</span>
                                                                                    :
                                                                                    <span className="icon" data-icon-font="?"></span>
                                                                                }
                                                                            </span>

                                                                        }
                                                                    </li>
                                                                    :
                                                                    <li className="user_pro_img" id="profile_img">
                                                                        <span className="icon" data-icon-font="?"></span>
                                                                    </li>
                                                                }
                                                                <li className="R13_white user-name" id="user_name">
                                                                    {this.state.isLogin && global.ftk != "" && this.state.loginUname && this.state.loginUname != '' ?
                                                                        <span>{this.state.loginUname}</span>
                                                                        :
                                                                        <span>
                                                                            <a href={service.getRedirectUrl(global.loginUrl + '?URL=' + global.currentURL)} target="_self">Login </a>
                                                                            <span> / </span>
                                                                            <a href={service.getRedirectUrl(global.registerUrl + '?URL=' + global.currentURL)} target="_self"> Register</a>
                                                                        </span>
                                                                    }
                                                                </li>
                                                                {this.state.isLogin && global.ftk != "" &&
                                                                    <li>
                                                                        <span className="arrow_link icon" data-icon-font="l"></span>
                                                                    </li>
                                                                }
                                                            </ul>
                                                            </a>
                                                                :
                                                                    <li className="user_pro_img" id="profile_img">
                                                                        <span className="icon" data-icon-font="?"></span>
                                                                    </li>
                                                                }
                                                        </span>
                                                    </li>
                                                </ul>
                                            </li>
                                            {this.menuData && this.menuData.mobile && this.menuData.mobile.map((item, i1) => (
                                                <li key={i1}>
                                                    {item.submenu && item.submenu.length > 0 ?
                                                        <ul>
                                                            <li className="shop_menucat" onClick={this.openSubMenu}>
                                                                <ul className="menucls">
                                                                    <li className="opening_list">
                                                                        <ul className="menucls">
                                                                            <li className="menu_icon left" >
                                                                                <img className="loadingImg menucls" src="https://cdn.cdnparenting.com/articles/babynameimages/loader.gif" data-src={item.image.replace("http://", "https://")} alt="" />
                                                                            </li>
                                                                            <li className="R15_42 menu_icon_txt left">{item.name}</li>
                                                                            <li id={item.arrowid} className="dash_link right" data-icon-font="8" ></li>
                                                                        </ul>
                                                                    </li>
                                                                </ul>
                                                            </li>
                                                            <li id={item.subid} className="sublist" style={dNone}>
                                                                <ul className="menucls">
                                                                    {item.submenu.map((subitem, i2) => (
                                                                        <a href={subitem.url} key={i2}>
                                                                            <li className="R14_75 menu_icon_txt shop_item"> {subitem.name} </li>
                                                                        </a>
                                                                    ))}
                                                                </ul>
                                                            </li>
                                                        </ul>
                                                        :
                                                        <ul>
                                                            <li className="shop_menucat">
                                                                <a href={service.getRedirectUrl(item.url)} className="left">
                                                                    <ul className="menucls" >
                                                                        <li className="menu_icon left">
                                                                            <img className="loadingImg menucls" src="https://cdn.cdnparenting.com/articles/babynameimages/loader.gif" data-src={item.image.replace("http://", "https://")} alt="" />
                                                                        </li>
                                                                        <li className="R15_42 menu_icon_txt left">{item.name}</li>
                                                                    </ul>
                                                                </a>
                                                            </li>
                                                        </ul>
                                                    }
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                                <div className="closingdiv" onClick={this.closeMobileMenu}></div>
                            </div>
                        </div>
                    </header>
                }
            </div>
        );
     }    
    }
}

export default Header;



// WEBPACK FOOTER //
// src/shared/header/Header.js